import axios from "axios";
import "../config";

export default {
  async getNotes() {
    return axios.get(`/notes`);
  },
  async delete(ids) {
    return axios.post(`/notes/delete`, {ids});
  },
  async move(data) {
    return axios.put(`/notes/move`, data);
  },
  async getShareNotes(shareUrl) {
    return axios.get(`/notes/share?shareUrl=${shareUrl}`);
  },
  async genShareUrl(noteIds) {
    return axios.put('/notes/gen-share-url', {noteIds});
  }
};
